import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const proxmox = defineConnector({
  identifier: "proxmox",
  name: "Proxmox VE",
  tagLine: "Virtualization management platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `${app.config.user}!${app.config.tokenName}=${app.secret.tokenValue}`,
        scheme: "PVEAPIToken",
      },
    ]),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Proxmox, go to **Datacenter → Permissions → API Tokens** and create a new token for your user.",
        },
      ],
    },
    {
      title: "Enter your Proxmox details",
      items: [
        {
          kind: "baseUrl",
          label: "Proxmox server URL",
          required: true,
          placeholder: "https://proxmox.example.com:8006",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Proxmox server.",
        },
        {
          kind: "input",
          label: "User",
          required: true,
          placeholder: "root@pam",
          target: { kind: "configuration", field: "user" },
          helperText: "The user and realm, e.g. root@pam.",
        },
        {
          kind: "input",
          label: "Token name",
          required: true,
          target: { kind: "configuration", field: "tokenName" },
        },
        {
          kind: "input",
          label: "Token value",
          required: true,
          target: { kind: "secrets", field: "tokenValue" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api2/json/version`,
  },
});
